import { render, staticRenderFns } from "./InfoCustomers.vue?vue&type=template&id=de629d28"
import script from "./InfoCustomers.vue?vue&type=script&lang=js"
export * from "./InfoCustomers.vue?vue&type=script&lang=js"
import style0 from "./InfoCustomers.vue?vue&type=style&index=0&id=de629d28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports